import { useState } from 'react';
import { Modal } from '@/components/dialogs/Modal';
import { TextField } from '@/components/forms/TextField';

interface SaveTemplateModalProps {
  show: boolean;
  busy?: boolean;
  onSubmit: (name: string) => void;
  onClose: () => void;
}

export function SaveTemplateModal({ show, busy = false, onSubmit, onClose }: SaveTemplateModalProps) {
  const [name, setName] = useState('');
  const [error, setError] = useState<string | undefined>(undefined);

  function handleSave() {
    const trimmed = name.trim();
    if (!trimmed) {
      setError('Please enter a template name.');
      return;
    }
    onSubmit(trimmed);
  }

  return (
    <Modal
      show={show}
      title="Save as template"
      onClose={onClose}
      footer={
        <>
          <button type="button" className="btn btn-light" onClick={onClose} disabled={busy}>
            Cancel
          </button>
          <button type="button" className="btn btn-primary" onClick={handleSave} disabled={busy}>
            {busy ? 'Saving…' : 'Save'}
          </button>
        </>
      }
    >
      <TextField
        label="Template name"
        value={name}
        error={error}
        onChange={(e) => {
          setName(e.target.value);
          if (error) setError(undefined);
        }}
      />
    </Modal>
  );
}
